/**
 * Default colors and fonts for the charting library.
 *
 * Put global styles in here to be shared across styled components.
 */
export const theme = {
  colors: {
    basicallyBlack: '#5a5a66',
    primaryCalloutHighlight: '#68A96C',
    primaryActiveHighlight: '#00B700',
    primaryElement: '#54687D',
    secondaryElement: '#97A7BA',
    calloutBackground: '#F7F9FA',
    chartBackgroundHighlight: '#E5E8EB',
    chartBackground: '#F6F7F8',
    chartLinePrimary: '#A4ADB8',
    chartLineSecondary: '#D6DADF',
    chartTextPrimary: '#9CA6B2',
    chartTextSecondary: '#C3C9D0',
    chartTextTertiary: '#57687B',
    chartTextInvertedPrimary: '#F9FCF9',
    disabled: '#C0C0C0',
    pastelGood: '#68A96C',
    pastelBad: '#e368a0',
    primaryBlue: '#2979FF',
  },
  fonts: {
    primaryFontFamily: 'Roboto,sans-serif',
  },
  charts: {
    heatmap: {
      saturationMin: '#ECECEC',
      saturationMax: '#4EA44B',
    },
  },
};
